import React, { useState, useEffect } from "react";
import { Button } from "flowbite-react";
import axios from "axios";
import { toast } from "react-toastify";
import LoadingOverlay from "./LoadingOverlay";
import ConfirmDialog from "./ConfirmDialog";

function UserLevel() {
  const [level, setLevel] = useState("");
  const [userLevelList, setuserLevelList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [uploadPending, setUploadPending] = useState(false);
  const [userLevelId, setUserLevelId] = useState("");

  useEffect(() => {
    getUserLevelList();
  }, []);

  const getUserLevelList = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(
        `https://eps.elkomprintama.com/get/api/users/levels`,
      );
      setuserLevelList(Array.isArray(response.data) ? response.data : []);
      const lastItem = response.data[response.data.length - 1];
      setUserLevelId(lastItem ? lastItem.user_lvl + 1 : "");
    } catch (error) {
      toast.error(error.response?.data?.msg || "Failed to fetch user levels");
      setuserLevelList([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleLevelNameChange = (e) => {
    setLevel(e.target.value);
  };

  function applyStripedStyle(index) {
    return index % 2 === 0 ? "border-b bg-gray-50" : " bg-white"; // Apply the striped-row class to even-indexed rows
  }

  const insertLevelName = async (e) => {
    setIsLoading(true);
    try {
      const response = await axios.post(
        `https://eps.elkomprintama.com/post/api/user/level`,
        {
          user_lvl: userLevelId,
          level_name: level.toUpperCase(),
        },
      );
      if (response.status === 200) {
        // Access the 'msg' property from the response data
        toast.success(response.data.msg); // This will display the success message
        getUserLevelList();
      }
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.msg);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!level || !userLevelId) {
      toast.warning("Please fill in location field");
      return;
    }
    setUploadPending(true);
    setShowConfirm(true);
  };

  return (
    <>
      <div className={`w-full  rounded-lg `}>
        <label
          className={`block uppercase text-white  mb-2 tracking-wide  text-2xl text-center  font-bold `}
        >
          New User Level
        </label>
      </div>
      <div className="relative h-full overflow-x-auto shadow-md px-5 bg-gray-200 sm:rounded-lg">
        <form className="my-5" onSubmit={handleSubmit}>
          <div className="field w-full my-2">
            <div className="control w-full  ">
              <div className="flex flex-wrap -mx-3 mb-5">
                <div className="w-1/6 px-3">
                  <label
                    className="block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                    htmlFor="level-id"
                  >
                    Level ID
                  </label>
                  <input
                    className=" border-gray-300 rounded px-3 py-2 bg-gray-100 text-gray-700"
                    id="level-id"
                    type="text"
                    placeholder="Level id"
                    disabled
                    value={userLevelId}
                  />
                </div>
                <div className="w-5/6 px-3">
                  <label
                    className="block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                    htmlFor="grid-pn"
                  >
                    Level
                  </label>
                  <input
                    className="appearance-none block w-full border bg-white border-green-400 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                    id="grid-pn"
                    type="text"
                    placeholder="Level Name"
                    onChange={handleLevelNameChange}
                    value={level.toUpperCase()}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="w-full ">
            <Button fullSized type="submit">
              Insert
            </Button>
          </div>
        </form>
        <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
          <table className="text-sm text-left table-auto text-gray-500 dark:text-gray-400 w-full border-collapse">
            <thead className="sticky top-0  text-white uppercase bg-gray-600 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th
                  scope="col"
                  className="whitespace-nowrap px-5 py-5 flex-1 border-r"
                >
                  Level ID
                </th>
                <th scope="col" className="whitespace-nowrap px-5 flex-1">
                  Level Name
                </th>
              </tr>
            </thead>
            <tbody>
              {userLevelList.map((data, index) => (
                <tr
                  className={`py-6  border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 ${applyStripedStyle(
                    index,
                  )}`}
                  key={data.user_lvl}
                >
                  <td className="whitespace-nowrap px-5 py-5 flex-1 border-r">
                    {data.user_lvl}
                  </td>
                  <td className="whitespace-nowrap px-5 flex-1">
                    {data.level}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {isLoading && <LoadingOverlay message="loading..." />}
        {showConfirm && uploadPending && (
          <ConfirmDialog
            message="Are you sure you want to insert the data?"
            onConfirm={() => {
              setShowConfirm(false);
              insertLevelName();
              setLevel("");
            }}
            onCancel={() => {
              setShowConfirm(false);
              setUploadPending(false);
            }}
          />
        )}
      </div>
    </>
  );
}

export default UserLevel;
